function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-34 -598)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.712 15.183H2.367c-1.044 0-1.893-.849-1.893-1.893V2.392c0-1.044.849-1.893 1.893-1.893h16.701c1.044 0 1.893.849 1.893 1.893V13.29c0 .9-.635 1.668-1.498 1.851l-3.75 4.376v-4.334zm.8 2.171l2.539-2.96.153-.02c.544-.067.957-.533.957-1.084V2.392c0-.602-.49-1.093-1.093-1.093H2.367c-.603 0-1.093.49-1.093 1.093V13.29c0 .602.49 1.093 1.093 1.093h14.145v2.971z",
  transform: "translate(35 178) translate(0 420)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.521 7.61c.328-.391.493-.847.493-1.363 0-.356-.086-.693-.257-1.01-.171-.319-.419-.578-.739-.777l-.079.128.08-.128c-.324-.2-.702-.3-1.131-.3-.59 0-1.082.188-1.468.563-.38.37-.613.834-.696 1.385l.107.167.71.202.025-.168c.06-.397.21-.707.452-.936.237-.226.525-.339.87-.339.264 0 .485.06.667.18.185.122.323.275.415.462.094.19.14.38.14.571 0 .382-.13.695-.392.949-.268.259-.642.426-1.125.5l-.128.153.078 2.113.15.144h.438l.15-.145.055-1.601c.485-.139.882-.39 1.185-.75zM10.888 10.462v-.15c-.15 0-.285.057-.394.166-.109.109-.165.243-.165.393 0 .158.057.294.168.4.108.105.241.16.39.16.157 0 .292-.055.399-.162.106-.106.16-.242.16-.398 0-.149-.053-.282-.158-.39-.107-.112-.243-.169-.4-.169v.15z",
  transform: "translate(35 178) translate(0 420)"
})))));

var SvgYellowFaqIcon = function SvgYellowFaqIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowFaqIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellow_faq_icon.b839ddf7.svg";
export { ForwardRef as ReactComponent };